var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.24004 0 0 4.95168 0 11.64C0 15.1384 1.43376 18.1615 3.76867 20.2495C3.96468 20.425 4.083 20.6707 4.09104 20.9338L4.15639 23.0683C4.17727 23.7492 4.88057 24.1922 5.50361 23.9172L7.88544 22.8658C8.08735 22.7767 8.3136 22.7602 8.52636 22.8187C9.62088 23.1197 10.7858 23.28 12 23.28C18.76 23.28 24 18.3283 24 11.64C24 4.95168 18.76 0 12 0Z",
    fill: "url(#paint0_radial_4632_49560)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79377 15.0441L8.31877 9.45166C8.87948 8.56198 10.0802 8.34046 10.9215 8.97142L13.7251 11.0741C13.9824 11.2671 14.3363 11.2661 14.5924 11.0717L18.3788 8.19802C18.8842 7.8145 19.5439 8.4193 19.2057 8.95601L15.6807 14.5485C15.12 15.4382 13.9192 15.6597 13.078 15.0287L10.2743 12.926C10.0171 12.7331 9.66313 12.7341 9.407 12.9285L5.62057 15.8021C5.1152 16.1856 4.45549 15.5808 4.79377 15.0441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4632_49560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.61938 23.8716) scale(26.1503 26.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609754,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934823,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbMessenger);
export default __webpack_public_path__ + "static/media/fb_messenger.d90fd5248bd0e47082f381038e01aca9.svg";
export { ForwardRef as ReactComponent };